import React, { PureComponent, Fragment } from 'react';
import { addEventListener } from '@ifeng/ui_base';
import PropTypes from 'prop-types';
import styles from './index.css';

class StaticVideo extends PureComponent {
    static propTypes = {
        sourceUrl: PropTypes.string,
        gotoUrl: PropTypes.string,
        posterUrl: PropTypes.string,
        videoStaticPic: PropTypes.string,
    };

    state = {
        isShowWatchTvIcon: false,
        isSupportVideo: true,
    };

    videoRef = React.createRef();

    componentDidMount() {
        const isSupportVideo = this.videoRef.current.canPlayType;

        this.setState({
            isSupportVideo: !!isSupportVideo,
        });

        if (isSupportVideo) {
            addEventListener(this.videoRef.current, 'ended', () => {
                this.setState({
                    isShowWatchTvIcon: true,
                });
            });
        }
    }

    render() {
        const { gotoUrl, posterUrl, sourceUrl, videoStaticPic } = this.props;
        const { isShowWatchTvIcon, isSupportVideo } = this.state;

        return (
            <a href={gotoUrl} target="_blank" className={styles.videoStaticBox}>
                {isSupportVideo ? (
                    <Fragment>
                        <video
                            ref={this.videoRef}
                            className={styles.videoStaticPlayer}
                            src={sourceUrl}
                            poster={posterUrl}
                            muted={true}
                            autoPlay={true}
                            type="video/mp4"
                            controls={false}
                        />
                        <img
                            className={`${styles.videoStaticPic} ${isShowWatchTvIcon ? styles.videoStaticPicShow : ''}`}
                            src="https://x0.ifengimg.com/ucms/2022_05/645AFB6CAE8E3FBFB4AC51B8EBF96C7C6049B301_size10_w260_h60.png"
                        />
                        <img
                            className={styles.liveIcon}
                            src="https://x2.ifengimg.com/fe/shank/channel/icon_living.5620d0b3.gif"
                        />
                    </Fragment>
                ) : (
                    <img src={videoStaticPic} className={styles.videoStaticUrl} />
                )}
            </a>
        );
    }
}

export default StaticVideo;
